var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isLoginRoute && !_vm.isResponsiveArticleRoute)?_c('navbar'):_vm._e(),_c('breadcrumb'),_c('debounce-load',{attrs:{"is-loading":_vm.isLoading}},[_c('router-view')],1),_c('journey-update-notification-tile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }